import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { PendingTransactionMessageComponent } from "./pending-transaction-message.component";

@NgModule({
    declarations: [
        PendingTransactionMessageComponent,
    ],
    exports: [
        PendingTransactionMessageComponent,
    ],
    imports: [
      CommonModule,
      BrowserAnimationsModule
    ]
  })
  export class PendingTransactionMessageModule {
  }
  